import clickToTextCastService from '@widgets/click-to-text/services/clickToTextCastService'
import type { ClickToTextSendMessagePayload } from '@widgets/click-to-text/types'
import { ApiService } from '@widgets/shared/services/apiService'
import type { ClickToTextForm } from '@/services/domain/services/forms/clickToText/types'
import type FormClickToTextDetails from '@/data/models/domain/services/forms/FormClickToTextDetails'

export class ClickToTextApiService extends ApiService {
  public async getSettings(uniqueCode: string): Promise<ClickToTextForm | null> {
    const path = `/api/v3/form/click-to-text/${uniqueCode}/embed`
    try {
      const { data } = await this.get<FormClickToTextDetails>(path)
      return clickToTextCastService.castEntityToForm(data)
    } catch (error) {
      if (this.isForbidenError(error) || this.isNotFoundError(error)) return null
      throw error
    }
  }

  public sendMessage(uniqueCode: string, payload: ClickToTextSendMessagePayload) {
    const path = `/api/v3/form/click-to-text/${uniqueCode}/send`
    return this.post(path, payload)
  }
}

export default new ClickToTextApiService()
